import axiosInstance from "../services/axiosInstance";

export const fetchSchedules = async ({
  companyId,
  page = 1,
  perPage = 10,
  search = "",
}) => {
  try {
    const response = await axiosInstance.get("console/schedule/get", {
      params: {
        company_id: companyId,
        page,
        perPage,
        search,
      },
    });

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const createSchedule = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/schedule/create",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateSchedule = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/schedule/update",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteSchedule = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/schedule/delete",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
